import React, { useState } from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Modal from '@components/common/Modals/Modal/Modal';
import Text from '@components/common/Text/Text';
import Confirmation from '@components/lpc/Pot/MainModule/Informations/ShareEmail/Confirmation/Confirmation';
import Invitation from '@components/lpc/Pot/MainModule/Informations/ShareEmail/Invitation/Invitation';
import Message from '@components/lpc/Pot/MainModule/Informations/ShareEmail/Message/Message';

import css from './ShareEmail.module.scss';

type ShareEmailProps = {
    isVisible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    potRef: string;
};

const ShareEmail = ({ potRef, isVisible, onHide }: ShareEmailProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    const [activeTab, setActiveTab] = useState(0);
    const [emailList, setEmailList] = useState([]);

    const onCancel = () => {
        onHide();
    };

    return (
        <Modal
            visible={isVisible}
            onHide={onHide}
            customClass={`${css.custom} ${activeTab === 2 && css.custom__confirmation}`}
            hideCloseButton={activeTab === 2}
            closeOnOverlayClick={activeTab !== 2}
        >
            <div className={css.container}>
                {activeTab !== 2 && (
                    <section className={css.container__top}>
                        <div className={css.container__top__tabs}>
                            <span
                                className={`${css.container__top__tabs__tab} ${
                                    activeTab === 0 && css.container__top__tabs__tab__active
                                }  `}
                            >
                                {t('invitation.invitation')}
                            </span>
                            <span className={css.container__top__tabs__tab}>{'>'}</span>
                            <span
                                className={`${css.container__top__tabs__tab} ${
                                    activeTab === 1 && css.container__top__tabs__tab__active
                                }  `}
                            >
                                {t('invitation.message')}
                            </span>
                        </div>

                        <h5>{t('invitation.title')}</h5>
                        <Text variant={'body_02'} color={'txt-secondary'}>
                            {t('invitation.subtitle')}
                        </Text>
                    </section>
                )}

                <div className={css.container}>
                    {/* FORM */}
                    {activeTab === 0 && (
                        <section className={css.form}>
                            <Invitation
                                potRef={potRef}
                                setActiveTab={(tab: number) => setActiveTab(tab)}
                                onCloseModal={() => onCancel()}
                                onSetEmailList={(list: string[]) => setEmailList(list)}
                                emailList={emailList}
                            />
                        </section>
                    )}
                    {activeTab === 1 && (
                        <section className={css.form}>
                            <Message
                                potRef={potRef}
                                setActiveTab={(tab: number) => setActiveTab(tab)}
                                emailList={emailList}
                            />
                        </section>
                    )}
                    {activeTab === 2 && (
                        <section className={css.form}>
                            <Confirmation
                                onCloseModal={() => {
                                    onCancel();
                                    setEmailList([]);
                                    // avoid seeing new tab before closing
                                    setTimeout(() => setActiveTab(0), 400);
                                }}
                            />
                        </section>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ShareEmail;
